<template>
  <v-app>
    <vis-app-bar />
    <v-main>
      <router-view />
    </v-main>

    <br />
    <br />
    <br />
    <v-footer>
      <div
        class="justify-center"
        style="
          margin: 0 auto 30px auto;
          max-width: 600px;
          text-align: center;
          padding-top: 0px;
          font-size: 12px;
        "
      >
        <div class="justify-center">
          <div
            class="justify-center"
            style="
              max-width: 600px;
              text-align: center;
              padding-top: 0px;
              border-bottom: 1px solid #087b7a;
            "
          >
            <center>
              <v-img
                src="@/assets/logo-arvalis.png"
                alt="Logo ARVALIS"
                width="300px"
                min-width="200px"
                text-align="center"
              />
            </center>
          </div>
          <router-link
            :to="{ name: 'mentionslegales' }"
            style="text-decoration: none; color: #0097ac"
          >
            Mentions légales
          </router-link>
          |
          <a
            href="http://arvalis.info/cguoad"
            style="text-decoration: none; color: #0097ac"
            target="_blank"
          >
            CGU
          </a>
          |
          <a
            href="mailto:contact@arvalis.fr?subject=Question sur le site distance-riverains.arvalis.fr"
            style="text-decoration: none; color: #0097ac"
          >
            Contact
          </a>
          | Distance Riverains est un outil d'ARVALIS - Institut du Végétal
        </div>
      </div>
    </v-footer>
    <notification-snackbar />
    <error-modal />
  </v-app>
</template>

<script lang="ts" setup>
//import route from "vue-router";
import NotificationSnackbar from "@/components/modals/NotificationSnackbar.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import visAppBar from "./components/layouts/visAppBar.vue";
</script>
